<!-- 设备运维 -->
<style lang="scss" scoped>
.equ-manage {
  position: relative;
  pointer-events: all;

  .left-content {
    position: absolute;
    width: 416px;
    height: 858px;
    right: 1397px;
    top: 135px;
  }

  .right-content {
    position: absolute;
    width: 415px;
    height: 854px;
    right: 44px;
    top: 135px;
  }
}
</style>
<template>
  <div class="equ-manage">
    <template v-if="getRouteName === pagesName">
      <custom-return></custom-return>
      <div class="left-content common-bg">
        <LeftFirst
          :number1="number1"
          :number2="number2"
          :number3="number3"
        ></LeftFirst>
        <LeftSecond :drainageList="drainageList"></LeftSecond>
        <RightThird :liftsList="liftsList"></RightThird>
        <gateway :GatewayList="GatewayList"></gateway>
      </div>
      <div class="right-content common-bg">
        <RightSecond :kongtiaoList="kongtiaoList"></RightSecond>
        <!-- <LeftThrid :lightingList="lightingList"></LeftThrid> -->
        <LeftFourth :xiaofangList1="xiaofangList1"></LeftFourth>
        <Pump :xiaofangList2="xiaofangList2"></Pump>
        <RightFirst :securityList="securityList"></RightFirst>
      </div>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>
<script>
import LeftFirst from "./components/left-first.vue";
import LeftSecond from "./components/left-second.vue";
import LeftThrid from "./components/left-thrid.vue";
import LeftFourth from "./components/left-fourth.vue";
import RightFirst from "./components/right-first.vue";
import RightSecond from "./components/right-second.vue";
import RightThird from "./components/right-third.vue";
import Gateway from "./components/gateway.vue";
import { getOperationHomePageData } from "@/api/index";
import Pump from "./components/pump.vue";
import bus from "@/components/three-scene/Bus.js";
export default {
  data() {
    return {
      timer: null,
      pagesName: "fourth",
      drainageList: [
        //给排水
        { title: "运行数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      lightingList: [
        //照明系统
        { title: "正常数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      xiaofangList1: [
        //消防烟感
        { title: "正常数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      xiaofangList2: [
        //消防水泵
        { title: "正常数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      securityList: [
        //消防卷帘门
        { title: "正常数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      kongtiaoList: [
        //空调
        { title: "正常数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      liftsList: [
        //电梯
        { title: "正常数量", num: "-" },
        { title: "待机数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      GatewayList: [
        //网关
        { title: "正常数量", num: "-" },
        { title: "故障数量", num: "-" },
      ],
      // 变配电
      number1: 0,
      number2: 0,
      number3: 0,
    };
  },
  components: {
    LeftFirst,
    LeftSecond,
    LeftThrid,
    LeftFourth,
    RightFirst,
    RightSecond,
    RightThird,
    Gateway,
    Pump,
  },
  created() {
    this.getHomeData();
    this.timer = setInterval(() => {
      this.getHomeData();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    async getHomeData() {
      let { data: res } = await getOperationHomePageData();
      // 变配电
      this.number1 = res.powerSupply.normal;
      this.number2 = res.powerSupply.standby;
      this.number3 = res.powerSupply.fault;

      // 给排水
      this.drainageList[0].num = res.waterSupply.normal;
      this.drainageList[1].num = res.waterSupply.standby;
      this.drainageList[2].num = res.waterSupply.fault;

      // 电梯
      this.liftsList[0].num = res.elevator.normal;
      this.liftsList[1].num = res.elevator.standby;
      this.liftsList[2].num = res.elevator.fault;

      // 网关
      this.GatewayList[0].num = res.gateway.normal;
      this.GatewayList[1].num = res.gateway.fault;

      // 空调系统
      this.kongtiaoList[0].num = res.airConditioning.normal;
      this.kongtiaoList[1].num = res.airConditioning.standby;
      this.kongtiaoList[2].num = res.airConditioning.fault;

      // 消防烟感
      this.xiaofangList1[0].num = res.smokeDetector.normal;
      this.xiaofangList1[1].num = res.smokeDetector.standby;
      this.xiaofangList1[2].num = res.smokeDetector.fault;

      // 消防水泵
      this.xiaofangList2[0].num = res?.firePump?.normal ?? "-";
      this.xiaofangList2[1].num = res?.firePump?.standby ?? "-";
      this.xiaofangList2[2].num = res?.firePump?.fault ?? "-";

      // 防火卷帘门
      this.securityList[0].num = res.fireDoor.normal;
      this.securityList[1].num = res.fireDoor.standby;
      this.securityList[2].num = res.fireDoor.fault;

      // 存数据至vuex中
      for (const item of this.liftsList) {
        this.$store.state.Elevator.push(item.num);
      }
    },
  },
  computed: {
    getRouteName() {
      return this.$route.name;
    },
  },
  mounted() {
    bus.emit("initDom");
    bus.emit("initDom1");
  },
};
</script>
